import { combineReducers } from "redux";
import desktop from "./desktop";
import companiesList from "./companiesList";

export default combineReducers({
    companiesList,
    desktop
});
